import React, { Component } from 'react';
import { useState, useEffect } from 'react';
import { basePort, setTokenHeader, getUsernameJwt, headers, isExpiredJwt, IsMbrTempRole, getJwtFromCookies, renderRedirect } from "../../module_auth/AuthService"
import 'react-quill/dist/quill.snow.css';
import { ShowSelectCity } from '../common/SelectList';
import { ToastMessage } from "../../component/common/Toast"
import { lazyReload } from '../common/BaseUtil';
import parse from 'html-react-parser';
import { useNavigate } from "react-router-dom";

export function MbrPvMypage() {
    const navigate = useNavigate();

    const [mbrId, setMbrId] = useState("");
    const [fullname, setFullname] = useState("");
    const [nickname, setNickname] = useState("");
    const [telno, setTelno] = useState("");
    const [email, setEmail] = useState("");
    // const [workCity, setWorkCity] = useState("0");
    // const [workTime, setWorkTime] = useState("0");
    // const [visaStat, setVisaStat] = useState("");
    // const [eduHist, setEduHist] = useState("");
    // const [resumeHist, setResumeHist] = useState("");
    // const [pvIntro, setPvIntro] = useState("");

    const [password, setPassword] = useState("");
    const [passwordRepeat, setPasswordRepeat] = useState("");
    const [accessToken, setAccessToken] = useState("");
    const [memberEntity, setMemberEntity] = useState("");

    const [redirectLogin, setRedirectLogin] = useState(false);
    //toast
    const [showToast, setShowToast] = useState(false);
    const [msgToast, setMsgToast] = useState("");

    const [cityList, setCityList] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    //modal
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        if (getJwtFromCookies() == null || isExpiredJwt(getJwtFromCookies()) || IsMbrTempRole(getJwtFromCookies())) {
            //alert
            setRedirectLogin(true)
            setIsLoading(false)
        } else {
            setAccessToken(getJwtFromCookies())
            setMbrId(getUsernameJwt(getJwtFromCookies()))
            //getCityList()
            setTokenHeader(getJwtFromCookies())
            fetch(basePort + '/get/pv/mypage',
                {
                    method: 'GET', headers,
                    body: JSON.stringify()
                })
                .then(response => response.json())
                .then(response => {
                    console.log("response.workCity: " + response.workCity)
                    setFullname(response.fullname)
                    setEmail(response.email)
                    setTelno(response.telno)
                    // setWorkCity(response.workCity)
                    // setWorkTime(response.workTime)
                    // setVisaStat(response.visaStat)
                    // setEduHist(response.eduHist)
                    // setResumeHist(response.resumeHist)
                    // setPvIntro(response.pvIntro)
                    setNickname(response.nickname)
                }).catch(error => console.log(error))
                .finally(() => {
                    setIsLoading(false)
                })

        }

    }, []);

    function getCityList() {
        let url = basePort + '/get/config'
        fetch(url,
            {
                method: 'GET', headers,
                body: JSON.stringify()
            })
            .then(response => response.json())
            .then(response => {
                console.log(response.cityEntityList)
                setCityList(response.cityEntityList)
            }).catch(error => console.log(error))
    }

    function handlePassword(event) {
        setPassword(event.target.value);
        console.log(event.target.value)
    }

    function handlePasswordRepeat(event) {
        setPasswordRepeat(event.target.value);
    }

    function handleTelno(event) {
        setTelno(event.target.value);
        console.log(event.target.value)
    }

    // function handleWorkCity(event) {
    //     setWorkCity(event.target.value);
    // }

    // function handleWorkTime(event) {
    //     setWorkTime(event.target.value);
    // }

    // function handleVisaStat(event) {
    //     setVisaStat(event.target.value);
    // }

    // function handleEduHist(event) {
    //     setEduHist(event.target.value);
    // }

    // function handleResumeHist(event) {
    //     setResumeHist(event.target.value);
    // }

    // function handlePvIntro(event) {
    //     setPvIntro(event.target.value);
    // }

    function clickSubmit(event) {
        moveTo()
    }

    function moveTo() {
        navigate("/mbr_pv_modi_mypage");
    }

    function fadeOutToast(msg) {
        setToastMessage(true, msg)
        setTimeout(function () {
            setToastMessage(false, "")
        }.bind(this), 3000);
    }

    function setToastMessage(show, message) {
        setShowToast(show)
        setMsgToast(message)
    }

    function changePasswordSubmit(event) {
        fetch(basePort + '/post/change/pwd',
            {
                method: 'post', headers,
                body: JSON.stringify({
                    mbrId: mbrId,
                    newPassword: password,
                    newPasswordRepeat: passwordRepeat,
                })
            })
            .then(response => response.json())
            .then(response => {
                console.log(response.jwtToken)
                if (response.validRequest) {
                    fadeOutToast(response.validationMessage)
                    lazyReload()
                } else {
                    fadeOutToast(response.validationMessage)
                }
            }).catch(error => console.log(error))
    }

    function closeModalBtn() {
        console.log("clickBtn")
        setShowModal(false)
    }

    function submitModalBtn() {
        console.log("submitBtn")
        setShowModal(false)
        changePasswordSubmit()
    }

    function clickModalBtn() {
        console.log("clickBtn")
        setShowModal(true)
    }

    function handleImage() {
        console.log("handleImage")
    }

    return (
        <div>
            {renderRedirect(redirectLogin, '/login')}
            <main class="page lanidng-page" style={{ opacity: isLoading ? 0.45 : 1, pointerEvents: isLoading ? 'none' : 'auto' }}>
                <section>
                    <div class="container" style={{ paddingTop: '100px', marginTop: '10px', marginBottom: '10px' }}>
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><span>마이페이지</span></li>
                            <li class="breadcrumb-item"><span>개인회원정보</span></li>
                        </ol>
                        <div class="card">
                            <div class="card-body" style={{ marginBottom: '10px' }}>
                                <form><label class="form-label">이름:</label><input class="form-control" type="text" value={fullname} disabled /></form>
                                <form style={{ marginTop: '10px' }}><label class="form-label">이메일:</label><input class="form-control" type="text" readonly="" value={email} disabled /></form>
                                <form style={{ marginTop: '10px' }}><label class="form-label">닉네임:</label><input class="form-control" type="text" value={nickname} disabled /></form>
                                <form style={{ marginTop: '10px' }}><label class="form-label">전화번호:</label><input class="form-control" type="text" value={telno} onChange={handleTelno} disabled /></form>
                                {/* <form style={{marginTop: '10px'}}><label class="form-label">근무도시:</label>
                                    <ShowSelectCity optionValue={workCity} cityList={cityList} handleWorkCity={handleWorkCity}/>
                                </form>
                                <form style={{marginTop: '10px'}} ><label class="form-label">근무형태:</label>
                                    <select class="form-select" disabled onChange={handleWorkTime} value={workTime}>
                                        <option value="0">선택</option>
                                        <option value="1">풀타임</option>
                                        <option value="2">파트타임</option>
                                        <option value="3">미니잡</option>
                                    </select>
                                </form>
                                <form style={{marginTop: '10px'}}><label class="form-label">비자상태:</label>
                                    <select class="form-select" disabled onChange={handleVisaStat} value={visaStat}>
                                        <option value="0" selected>선택</option>
                                        <option value="1">유학생비자</option>
                                        <option value="2">워킹홀레데이비자</option>
                                        <option value="3">취업준비비자</option>
                                        <option value="4">워킹비자</option>
                                    </select>
                                </form>
                                <form style={{margin: '10px', marginRight: '0', marginLeft: '0'}}>
                            <label class="form-label">학력사항:</label>
                            <div className="card" style={{minHeight: '100px', marginBottom: '10px', backgroundColor: '#e9ecef', color: '#212529', pointerEvents: 'none', opacity: '1'}}>
                                <div className="card-body">
                                {eduHist === null ? "" : parse(eduHist)}
                                </div>
                            </div>
                        </form>
                        <form style={{margin: '10px', marginRight: '0', marginLeft: '0'}}>
                            <label class="form-label">경력사항:</label>
                            <div className="card" style={{minHeight: '100px', marginBottom: '10px', backgroundColor: '#e9ecef', color: '#212529', pointerEvents: 'none', opacity: '1'}}>
                                <div className="card-body">
                                    {resumeHist === null ? "" : parse(resumeHist)}
                                </div>
                            </div>
                        </form>
                        <form style={{margin: '10px', marginRight: '0', marginLeft: '0'}}>
                            <label class="form-label">자기소개:</label>
                            <div className="card" style={{minHeight: '100px', marginBottom:'10px', backgroundColor: '#e9ecef', color: '#212529', pointerEvents: 'none', opacity: '1'}}>
                                <div className="card-body">
                                    {pvIntro === null ? "" : parse(pvIntro)}
                                </div>
                            </div>
                        </form>
                         */}
                                <ul class="list-group"></ul>
                            </div>
                            <form style={{ textAlign: 'center', marginBottom: '10px' }}><button class="btn btn-primary" type="button" onClick={clickSubmit}>수정하기</button></form>
                        </div>
                        {/* end of container */}
                        <ToastMessage show={showToast} msg={msgToast} />
                    </div>
                </section>
            </main>
            {isLoading && (
                <div
                    className="d-flex justify-content-center align-items-center"
                    style={{
                        position: 'fixed',
                        inset: 0,
                        backgroundColor: 'rgba(128, 128, 128, 0.22)',
                        zIndex: 1050
                    }}
                >
                    <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            )}
        </div>
    );
}